<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
  <div :class="is_weixin || is_app?'':'common-home-content'">
      <div class="home-header" v-if="!is_weixin && !is_app">
        <span class="title">智慧开方</span>
    </div>
    <div class="page-loading" v-show="!show">
        <div class="loading-content">
            <img src="../assets/images/page_loading.gif">
            <p class="loading-title">正在加载...</p>
        </div>
    </div>
    <div v-show="show">
      <div class="tab-container clearfix ice_bg">
          <div class="zhen-tabs">
              <ul class="tabs-main clearfix">
                  <li><router-link class="a actived" to="/">症状</router-link></li>
                  <li><router-link class="a" to="/cj">疾病</router-link></li>
                  <li><router-link class="a" to="ks">科室</router-link></li>
              </ul>
          </div>
      </div>
      <div class="title ice_bg space_pl clearfix">
          <span class="title-text background_color product-color">常见症状</span>
          <div id="priorityDropdown" class="priorityDropdown fr">
              <span id="priorityDropdownText" class="priorityDropdownText" @click="priorityClick(0, '', '')">{{priority_text}}</span>
              <span class="triangle_b" :class="priority_show?'triangle_t':''"></span>
              <ul class="priorityDropdownList ice_bg" :class="priority_show?'':'none'">
                  <li data-id="10" class="priorityBtn" :class="priority_text == '标准优先'?'selected':''" @click="priorityClick(1, '标准优先', 10)">标准优先</li>
                  <li data-id="20" class="priorityBtn" :class="priority_text == '教材优先'?'selected':''" @click="priorityClick(1, '教材优先', 20)">教材优先</li>
                  <li data-id="50" class="priorityBtn" :class="priority_text == '古籍优先'?'selected':''" @click="priorityClick(1, '古籍优先', 50)">古籍优先</li>
                  <li data-id="30" class="priorityBtn" :class="priority_text == '国医大师优先'?'selected':''" @click="priorityClick(1, '国医大师优先', 30)">国医大师优先</li></ul>
              <span style="display:block;width:1px;"></span>
          </div>
          <span class="fr switchModule unReady" id="switchModule" @click="diseaseClick()">限定病种
              <span class="triangle_b" :class="disease_show?'triangle_t':''"></span></span>
      </div>
      <div class="diagnosis-container">
          <div class="selectArea clearfix">
              <div id="diseaseField" class="diseaseField ice_bg">
                  <div id="diseaseContainer" class="diseaseContainer">
                      <div class="filterField">
                          <input type="text" class="filterText br_radius_none" v-model="keyword" id="filterText" @input="inputword()" placeholder="首字母过滤，如: gm 代表 感冒">
                          <button id="delFilterText" class="delFilterText" @click="clearword()">清除</button></div>
                      <div id="departmentList-container" class="departmentList-container">
                          <ul id="departmentList" class="departmentList clearfix">
                              <li class="li-option" :class="department_index == index?'actived':''" v-for="(department, index) in departments" :key="index" @click="departmentClick(index, department.id)">
                                  <div class="a">
                                      <div class="display_table">
                                          <span class="option" :class="department.name.length > 5?'font_2':''">
                                              <span v-if="department.name == '耳鼻喉科'">耳鼻喉</span>
                                              <span v-else-if="department.name == '传染病科'">传染科</span>
                                              <span v-else-if="department.name == '精神病科'">精神科</span>
                                              <span v-else>{{department.name}}</span></span>
                                      </div>
                                  </div>
                              </li>
                          </ul>
                      </div>
                      <div class="disease-swiper-container">
                          <van-swipe v-if="diseaseList.length>0" :options="swiperOption" ref="swiper" class="disease-swiper-wrapper">
                              <van-swipe-item v-for="(disease, index) in diseaseList" :key="index">
                                  <div class="li-option" :class="disease_id == child.id?'disabled':''" v-for="(child, index) in disease" :key="index" @click="optionClick2(child.id, child.xpy, child.label)">
                                      <div class="a">
                                          <span class="display_table">
                                              <span data-type="disease" class="option" :class="child.label.length > 5?'font_2':''">{{child.label}}</span></span>
                                      </div>
                                  </div>
                              </van-swipe-item>
                          </van-swipe>
                          <div class="swiper-button-prev arr_l" @click="handleSwipe('prev')"></div>
                          <div class="swiper-button-next arr_r" @click="handleSwipe('next')"></div>
                        </div>
                  </div>
              </div>
              <div id="categoriesField" class="categoriesField ice_bg clearfix">
                  <ul id="symptomCategories" class="symptomCategories fl clearfix">
                      <li class="li-option" :class="categorie_index == index?'actived':''" v-for="(categorie, index) in categories" :key="index" @click="changeClick(index, categorie.id)">
                          <div class="a">
                              <div class="display_table">
                                  <span class="option" :class="index == 1 || index == 3 || index == 4?'font_2':''" data-id="id">{{categorie.name}}</span></div>
                          </div>
                      </li>
                  </ul>
                  <ul id="symptomList" class="symptomList fl">
                      <li class="li-option" :class="[showarr.indexOf(primarie.id) > -1?'disabled':'', primarie.disabled?'symptomsDisabled' : '']" v-for="(primarie, index) in primaries" :key="index" @click="optionClick(primarie.id, primarie.label, primarie.disabled)">
                          <div class="a">
                              <div class="display_table">
                                  <span data-type="symptom" data-id="${id}" class="option" :class="primarie.label.length > 5?'font_2':''">{{primarie.label}}</span></div>
                          </div>
                      </li>
                  </ul>
              </div>
          </div>
          <div id="pageView" class="ice_bg space_mt">
              <div class="space_pl">
                  <div id="section-title" class="section-title dis-margin div-title-wap clearfix" v-if="disease_results.length > 0">
                      <span class="section-title-text background_color product-color fl">已选</span>
                      <div class="delete-con" id="deleteAll" @click="delAllDisease()">
                          <div class="deleteAll">
                              <div class="icon delete_after"></div>
                          </div>
                      </div>
                  </div>
                  <div class="selectResults-container dis-margin" v-if="disease_results.length > 0">
                      <ul id="selectResults" class="selectResults clearfix">
                          <li class="li-option text-opening" v-for="(child, index) in disease_results" :key="index" @click="delDisease(child.id, child.xpy)">
                              <div class="a display_table pl5 pr5">
                                  <span data-type="disease" class="option" :class="child.label.length >5?'font_2':''">{{child.label}}</span></div>
                          </li>
                      </ul>
                  </div>
                  <div class="relatedSymptoms-container dis-margin" v-if="related_symptoms.length > 0">
                      <p class="section-title-yesorno">是否出现以下症状</p>
                      <ul id="relatedSymptoms" class="relatedSymptoms clearfix">
                          <li class="li-option text-opening" v-for="(child, index) in related_symptoms" :key="index" @click="optionClick3(child.id, child.label)">
                              <div class="a display_table pl5 pr5">
                                  <span data-type="symptom" class="option" :class="child.label.length >5?'font_2':''">{{child.label}}</span></div>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
          <div class="ice_bg space_mt space_pl" v-if="search_show">
              <p id="diagnoseResult-title" class="diagnoseResult-title section-title dis-margin-Result" v-if="search_results.length > 0">诊断建议</p>
              <ul id="diagnosisResult" class="diagnosisResult" v-if="search_results.length > 0">
                  <li class="result-item dis-margin" data-id="did" :class="result.free?'free':''" v-for="(result, index) in search_results" :key="index"
                    @click="referenceClick(result.did, index)"
                  >
                      <div class="resultItemBtn arr_b"
                        :class="select_reference_dids.indexOf(result.did) > -1?'none':''"
                      ></div>
                      <h2 class="groupNameTitle-span">
                          <span class="groupNameTitle">
                              <span class="groupName-color">{{result.title}}</span>
                              <span class="iconArea" v-if="result.free">
                                  <span class="icon-container free_icon"></span>
                              </span>
                          </span>
                      </h2>
                      <div class="summaryList clearfix space_pr">
                          <label class="result-label">症状：</label>
                          <span v-for="(child, child_index) in result.symptoms" :key="child_index">
                              <span v-if="child_index > 0">、</span>
                              <span class="summary-option" :class="['summary-'+child.c, child.m?'summary-option-color':'']">{{child.l}}</span></span>
                      </div>
                      <div class="reference"
                        :class="select_reference_dids.indexOf(result.did) > -1?'':'none'"
                      >
                        <ul class="diagnosisReference space_pr"
                          :class="select_reference_dids.indexOf(result.did) > -1?'':'none'"
                        >
                            <li 
                              v-show="result.detail"
                            >
                                <p
                                v-for="(reference, references_index) in result.detail"
                                :key="references_index"
                                ><label class="result-label">{{reference.name}}：</label><span v-html="reference.value"></span></p>
                                <p>{{result.book}}</p>
                            </li>
                        </ul>
                        <div class="putUp"
                          :class="select_reference_dids.indexOf(result.did) > -1?'':'none'"
                          @click.stop="referencePutUp(result.did)"
                        ><span>收起</span></div>
                      </div>
                  </li>
              </ul>
              <ul id="diagnosisResult" class="diagnosisResult" v-if="null_show && search_results.length == 0">
                  <li id="diagnoseIsNull" class="diagnoseIsNull space_pt space_pl space_pr space_pb">无诊断建议，建议更换症状或病种。</li></ul>
          </div>
        </div>
    </div>
    <div class="mobile_get_more" v-if="loading && search_results.length > 0">
        <img class="more_loading_img" src="../assets/images/loading_20160819.gif" alt="">正在加载...
    </div>
    <div class="mobile_get_more" v-if="not_more && search_results.length > 0">
      <img class="no_more_img_left" src="../assets/images/mobile_no_more20161216.png" alt="">没有更多了<img class="no_more_img_right" src="../assets/images/mobile_no_more20161216.png" alt="">
    </div>
    <div id="recommendMsg" class="recommendMsg"></div>
    <p id="resultIsNull" class="resultIsNull ice_bg space_pl space_pr space_pt space_pb" v-if="!search_show">请选择症状</p>
</div>
</template>

<script>
import {deviceType} from '../utils/deviceType'
import secret from '../utils/secret'
import diagController from '../utils/diagController'
import $ from 'jquery';
import {_} from 'vue-underscore';

export default {
  name:'index',
  data() {
    return {
      locData: {},
      search_results: [],
      search_show: false,
      null_show: true,
      keyword: '',
      categories: [],
      primaries: [],
      primarie_id: 0,
      primarie_obj:{},
      departments: [],
      department_id: 0,
      diseaseList: [],
      disease_id: null,
      disease_arr: [],
      showarr: [],
      disease_results: [],
      related_symptoms: [],
      reference_dids: [],
      select_reference_dids: [],
      categorie_index: 0,
      department_index: 0,
      priority_show: false,
      disease_show: false,
      priority_id: 10,
      priority_text: '标准优先',
      loading: false,
      has_more: false,
      not_more: false,
      show:false,
      is_app: deviceType.isApp,
      is_weixin: deviceType.isWeiXin,
      swiperOption: {
        loop: true,
        initialSlide: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        observeParents: true
      }
    };
  },
  created() {
    var that = this;
    that.$api.get("/zhen/old/menu").then(function(res) {
        that.locData = secret.jiemi(res.data);
        diagController.newinit(that.locData);
        that.categories = diagController.getCategories();
        that.primaries = diagController.getPrimariesOfCategory(that.primarie_id);
        that.departments = diagController.getDepartments();
        that.diseaseList = that.pageSlide(diagController.getDiseases(that.department_id, that.keyword));
        var q = that.$utils.getUrlKey("q");
        if(q){
          var obj = that.checkDiseaseIdIn(q, that.locData.diseases);
          that.optionClick2(obj.id, obj.xpy, obj.label);
        }
        that.show = true;
        that.$appUtils.appCloseLoadingView();
        window.onscroll = () => {
          //变量scrollTop是滚动条滚动时，距离顶部的距离
          var scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          //变量windowHeight是可视区的高度
          var windowHeight =
            document.documentElement.clientHeight || document.body.clientHeight;
          //变量scrollHeight是滚动条的总高度
          var scrollHeight =
            document.documentElement.scrollHeight || document.body.scrollHeight;

          if((windowHeight + scrollTop) >= (scrollHeight -44)
            && that.has_more
            && !that.loading
          ){
            that.loading = true;
            that.searchDiagnose();
          }
        }
    });
    window.appBack = ()=> this.pageback();
  },
  methods: {
    checkDiseaseIdIn(diseaseName, diseaseList){ //检验疾病字符串id
        for(var i=0; i<diseaseList.length; i++){
            if(diseaseList[i][1] == diseaseName){
                return {"id": diseaseList[i][0], "label": diseaseList[i][1], "xpy": diseaseList[i][2]};
            }
        }
        return false;
    },
    searchDiagnose(){
      var that = this;
      that.null_show = false;
      var param = {};
      param['s'] = that.search_results.length;
      param['e'] = param['s'] + 5;
      if(this.disease_id){
        param['d'] = that.disease_id;
      }
      if(that.showarr.length > 0){
        param['z'] = that.showarr;
      }
      that.$api.get("/zhen/old/diag", {params: param}).then(function(res) {
          var result = res.data;
          that.search_results = that.search_results.concat(result.digests)
          if(that.search_results.length >= result.total){
            that.has_more = false;
            that.not_more = true;
          }else{
            that.has_more = true;
          }
          that.null_show = true;
          that.loading = false;
      });
    },
    pageSlide(list){
      var arr = new Array();
      var arr2  = new Array();
      for (var i=1;i<=list.length;i++){
        arr2.push(list[i-1]);
        if(parseInt(i) % 16 == 0){
          arr.push(arr2);
          arr2  = new Array();
        }
      }
      if(arr2.length > 0){
        arr.push(arr2);
      }
      return arr;
    },
    initDiseaseResult(){
      this.disease_results = [];
      if(this.disease_arr.length > 0){
        this.disease_results = this.disease_results.concat(this.disease_arr)
      }
      if(this.primarie_obj.id){
        this.disease_results.push(this.primarie_obj);
      }
      if(this.disease_results.length > 0){
        this.search_show = true;
      }else{
        this.search_show = false;
      }
      this.search_results = [];
      this.select_reference_dids = [];
      this.reference_dids = [];
      this.searchDiagnose();
    },
    updateRelatedSymptoms(operation, type, id){
      this.related_symptoms = [];
      if(operation == "select"){
            if(type == 0){
                diagController.selectDisease(id);
            }else if(type == 1){
                diagController.selectSymptom(id);
            }
        }else if(operation == "unselect"){
            if(type == 0){
                diagController.unselectDisease(id);
            }else if(type == 1){
                diagController.unselectSymptom(id);
            }
        }
        this.related_symptoms = diagController.getRelatedSymptoms().splice(0, 8);
    },
    delAllDisease(){
      this.disease_results = [];
      this.related_symptoms = [];
      this.disease_arr = [];
      this.showarr = [];
      this.disease_id = null;
      this.primarie_obj = {};
      diagController.clearSelectedDiseases();
      this.primaries = diagController.getPrimariesOfCategory(this.primarie_id);
      this.initDiseaseResult();
      
    },
    delDisease(id, xpy){
      this.disease_results = _.filter(this.disease_results, function(sel){ return sel.id != id; });
      if(xpy){
        this.disease_id = null;
        this.primarie_obj = {};
        diagController.clearSelectedDiseases();
        this.primaries = diagController.getPrimariesOfCategory(this.primarie_id);
        this.updateRelatedSymptoms("unselect", 0, id);
      }else{
        this.disease_arr = _.filter(this.disease_arr, function(sel){ return sel.id != id; });
        this.showarr.splice(this.showarr.indexOf(id),1);
        this.updateRelatedSymptoms("unselect", 1, id);
      }
      if(this.disease_results.length > 0){
        this.search_show = true;
      }else{
        this.search_show = false;
      }
      this.search_results = [];
      this.reference_dids = [];
      this.select_reference_dids = [];
      this.searchDiagnose();
    },
    changeClick(index, id){
      if(this.categorie_index == index) return;
      this.categorie_index = index;
      this.primarie_id = id;
      this.primaries = diagController.getPrimariesOfCategory(this.primarie_id);
    },
    optionClick(id, label,disabled){
        if(disabled) return;
        if(this.showarr.indexOf(id) > -1){
          this.showarr.splice(this.showarr.indexOf(id),1);
          this.disease_arr = _.filter(this.disease_arr, function(sel){ return sel.id != id; });
          this.updateRelatedSymptoms("unselect", 1, id);
        }else{
          this.showarr.push(id);
          this.disease_arr.push({'id': id, 'label': label});
          this.updateRelatedSymptoms("select", 1, id);
        }
        this.initDiseaseResult();
    },
    optionClick2(id, xpy, label){
        if(this.disease_id == null){
          this.disease_id = id;
          diagController.selectDisease(this.disease_id);
          this.primarie_obj = {'id': id, 'xpy': xpy, 'label': label};
          this.updateRelatedSymptoms("select", 0, id);
        }else{
          if(this.disease_id == id){
              this.disease_id = null;
              this.primarie_obj = {};
              diagController.clearSelectedDiseases();
              this.updateRelatedSymptoms("unselect", 0, id);
          }else{
              this.disease_id = id;
              this.showarr = [];
              this.disease_arr = [];
              diagController.selectDisease(this.disease_id);
              this.primarie_obj = {'id': id, 'xpy': xpy, 'label': label};
              this.updateRelatedSymptoms("select", 0, id);
          }
        }
        this.primaries = diagController.getPrimariesOfCategory(this.primarie_id);
        $('#diseaseField').animate({"top": "-468px"}, 300, function(){
          $(".diagnosis-container").removeClass('diagnosisMinHeight');
        });
        this.disease_show = false;
        this.initDiseaseResult();
    },
    optionClick3(id, label){
      this.showarr.push(id);
      this.disease_arr.push({'id': id, 'label': label});
      this.updateRelatedSymptoms("select", 1, id);
      this.initDiseaseResult();
    },
    departmentClick(index, id){
      if(this.department_index == index) return;
      this.department_index = index;
      this.department_id = id;
      this.diseaseList = this.pageSlide(diagController.getDiseases(id, this.keyword));
    },
    diseaseClick(){
      this.disease_show = !this.disease_show;
      if(this.disease_show){
        $(".diagnosis-container").addClass('diagnosisMinHeight');
        $('#diseaseField').animate({"top": 0}, 300, function(){});
      }else{
        $('#diseaseField').animate({"top": "-468px"}, 300, function(){
          $(".diagnosis-container").removeClass('diagnosisMinHeight');
        });
      }
      this.priority_show = false;
    },
    handleSwipe(type){
      if(type == 'prev'){
        this.$refs.swiper.prev();
      }else{
        this.$refs.swiper.next();
      }
    },
    priorityClick(type, text, id){
      if(type == 0){
        this.priority_show = !this.priority_show;
      }else{
        this.priority_show = false;
        this.priority_text = text;
        this.priority_id = id;
        this.search_results = [];
        this.select_reference_dids = [];
        this.reference_dids = [];
        this.searchDiagnose();
      }
    },
    referenceClick(did, index){
      var that = this;
      if(that.select_reference_dids.indexOf(did) > -1) return;
      if(that.reference_dids.indexOf(did) < 0){
        var param = {
            did: did,
            p: this.priority_id
        }
        that.$api.get("/zhen/old/ref", {params: param}).then(function(res) {
            var reference = res.data;
            that.search_results[index]['detail'] = reference.detail;
            that.search_results[index]['book'] = reference.book;
            that.select_reference_dids.push(did);
            that.reference_dids.push(did);
        });
      }else{
        that.select_reference_dids.push(did);
      }
      
    },
    referencePutUp(did){
      this.select_reference_dids.splice(this.select_reference_dids.indexOf(did),1);
    },
    clearword(){
      this.keyword = '';
      this.diseaseList = this.pageSlide(diagController.getDiseases(this.department_id, this.keyword));
    },
    inputword(){
      this.diseaseList = this.pageSlide(diagController.getDiseases(this.department_id, this.keyword));
    },
    pageback(){
        return null;
    } 
  }
}
</script>

